import { render } from "./InputTextNewTheme.vue?vue&type=template&id=597f6609&scoped=true"
import script from "./InputTextNewTheme.vue?vue&type=script&lang=js"
export * from "./InputTextNewTheme.vue?vue&type=script&lang=js"

import "./InputTextNewTheme.vue?vue&type=style&index=0&id=597f6609&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597f6609"]])

export default __exports__